import { render, staticRenderFns } from "./RepairTypeUpdate.vue?vue&type=template&id=f37b55ba"
import script from "./RepairTypeUpdate.vue?vue&type=script&lang=js"
export * from "./RepairTypeUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports